const getPrevDays = (days: number, currentTS: number) => currentTS - 1000 * 60 * 60 * 24 * days

const liftPageUtils = { getPrevDays }
export default liftPageUtils
